<template>
  <div id="tab" v-loading="loading"
    :style="{ width: controlForm.printLodopWidth * 3.77 + 'px', height: controlForm.printLodopHeight * 3.77 + 'px' }">
    <div class="controlForm">
      <el-form>
        <el-form-item class="form-item">
          <el-button type="primary" @click="onSubmit(1)">打印预览</el-button>
          <el-button type="primary" @click="onSubmit(2)">打印</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="main" v-for="($item, $index) in oneTicketPrintList" :key="$index">
      <div class="tableHead">
        <div class="title bold">
          <p>食品进销货电子一票通</p>
          <p>
            <span>NO：{{ $item.oneTicketPrintFooter.circulateLicense }}-XS--</span>
            <span class="headDate">日期：{{ $item.oneTicketPrintFooter.entryDate }}</span>
          </p>
        </div>
        <el-descriptions :column="2" border labelClassName="headTableLabel" contentClassName="headTableContent">
          <el-descriptions-item label="购货商名称">{{ $item.oneTicketPrintHead.customerName }}</el-descriptions-item>
          <el-descriptions-item label="负责人">{{ $item.oneTicketPrintHead.bossName }}</el-descriptions-item>
          <el-descriptions-item label="经营地址">{{ $item.oneTicketPrintHead.address }}</el-descriptions-item>
          <el-descriptions-item label="联系电话" contentClassName="headTableContentCirculation">{{ $item.oneTicketPrintHead.phoneNumber }}</el-descriptions-item>
        </el-descriptions>

      </div>
      <div class="tableBody">
        <table class="table" border="1" cellSpacing="0" cellPadding="0">
          <colgroup>
            <col width="50" />
            <col width="210" />
            <col width="80" />
            <col width="100" />
            <col width="80" />
            <col width="80" />
            <col width="120" />
            <col width="100" />
            <col width="100" />
          </colgroup>
          <thead>
            <tr class="noSetHeight">
              <th colspan="10"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td width="50" >序号</td>
              <td width="210">食品名称</td>
              <td width="80" >规格</td>
              <td width="100">数量</td>
              <td width="80" >售价(元)</td>
              <td width="80" >金额(元)</td>
              <td width="120">食品条形码</td>
              <td width="100">生产日期</td>
              <td width="100">保质期(天)</td>
            </tr>
            <tr v-for="(item, index) in $item.oneTicketPrintDetailList" :key="index">
              <td width="50" >{{ index + 1 }}</td>
              <td width="210">{{ item.itemName }}</td>
              <td width="80" >{{ item.itemSpec }}</td>
              <td width="100">{{ item.billQtyStr }}</td>
              <td width="80" >{{ item.billPriceStr }}</td>
              <td width="80" >{{ item.subZeroTotalAmt }}</td>
              <td width="120">{{ item.invBarCode }}</td>
              <td width="100">{{ item.productionDate }}</td>
              <td width="100">{{ item.validDays }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="noSetHeight">
              <td colspan="10" style=""></td>
            </tr>
          </tfoot>

        </table>
      </div>
      <div class="tableFooter">
        <el-descriptions class="sumContext" :column="2" border labelClassName="headTableLabelSumContext" contentClassName="headTableContent">
          <el-descriptions-item label="合计金额">{{ $item.sumContext }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="2" border labelClassName="footTableLabel" contentClassName="headTableContent">
          <el-descriptions-item label="供应商名称">{{ $item.oneTicketPrintFooter.supplierName }}</el-descriptions-item>
          <el-descriptions-item label="负责人">{{ $item.oneTicketPrintFooter.supplierBossName }}</el-descriptions-item>
          <el-descriptions-item label="企业注册号">{{ $item.oneTicketPrintFooter.enterpriseRegistNum }}</el-descriptions-item>
          <el-descriptions-item label="流通许可证号" contentClassName="headTableContentCirculation">{{ $item.oneTicketPrintFooter.circulateLicense }}</el-descriptions-item>
          <el-descriptions-item label="营业执照有效期">{{ $item.oneTicketPrintFooter.registNumDate }}</el-descriptions-item>
          <el-descriptions-item label="许可证有效期">{{ $item.oneTicketPrintFooter.licenseDate }}</el-descriptions-item>
          <el-descriptions-item label="经营地址">{{ $item.oneTicketPrintFooter.supplierAddress }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ $item.oneTicketPrintFooter.supplierPhone }}</el-descriptions-item>
          <el-descriptions-item label="送货车号">{{ $item.oneTicketPrintFooter.deliverVehicleNum }}</el-descriptions-item>
          <el-descriptions-item label="送货人">{{ $item.oneTicketPrintFooter.deliverUserName }}</el-descriptions-item>
        </el-descriptions>
        <div class="describe bold">
          <p>盖章</p>
          <p>声明：以上所售食品，本单位已履行法定检验义务，其合格证明文件已上传食药局电子数据库。</p>
        </div>
        <p class="pagination">
          <span>当前第
            <font tdata="PageNO" color="blue">##</font>页
          </span>
          <span>共<font tdata="PageCount" color="blue">##</font>页</span>
        </p>
        <div v-if="controlForm.isPrintPage == 'N'" :style="{ height: controlForm.bottomLodopHeight + 'px' }"></div>
      </div>
    </div>

  </div>
</template>
<script>
import { getLodop } from '@/assets/js/lodopFuncs.js';
export default {
  name: "OneTicketPass",
  props: ['billNo'],
  data() {
    return {
      loading: false,
      controlForm: {
        printLodopWidth: 210,
        printLodopHeight: 297
      },
      oneTicketPrintList: [],
      bodyStyle: `<style>.table thead > tr:not(.noSetHeight) th:not(.headclass),.table tbody > tr td,.table tfoot > tr:not(.noSetHeight) td:not(.footclass) {box-sizing: border-box;padding: 2px 4px;}
      p{margin: 0; padding: 0;}
      .el-descriptions {
        box-sizing: border-box;
        font-size: 14px;
        color: #303133;
      }
      .el-descriptions .is-bordered .el-descriptions-item__cell {
        border: 1px solid #000;
      }
      .el-descriptions__body {
        color: #606266;
        background-color: #FFF;
      }
      .el-descriptions .is-bordered {
        table-layout: auto;
      }
      .el-descriptions__body .el-descriptions__table {
        border-collapse: collapse;
        width: 100%;
        table-layout: fixed;
      }
      table {
        border-collapse:collapse;
        border-spacing:0;
        padd:expression(this.cellPadding=0);
      }
      .tableBody {
        width: 100%;
        overflow: hidden;
      }
      .tableBody .table {
        border-collapse: collapse;
        width: 100%;
        table-layout: auto;
      }
      .tableFooter,
      .tableHead {
        width: 100%;
      }
      .form-item .el-form-item__content {
        text-align: center;
      }
      .table thead > tr:not(.noSetHeight) th:not(.headclass),
      .table tbody > tr td,
      .table tfoot > tr:not(.noSetHeight) td:not(.footclass) {
        box-sizing: border-box;
        padding: 2px 4px;
      }
      .bold {
        font-weight: bold;
      }
      .el-descriptions .is-bordered .el-descriptions-item__cell {
        border: 1px solid #000;
        padding: 0 12px;
      }
      .headTableLabel {
        width: 120px;
        background: #fff !important;
        color: #000 !important;
        font-weight: 400;
      }
      .headTableContent {
        min-width: 50px;
        color: #000 !important;
      }
      .tableHead .title > p:nth-child(1) {
        font-size: 24px;
        text-align: center;
      }
      .tableHead .title > p:nth-child(2) {
        display: flex;
        justify-content: space-between;
      }
      .tableHead .title > p:nth-child(2) .headDate {
        width: 200px;
        font-size: 18px;
      }
      .tableHead .headTableContentCirculation {
        width: 230px;
        color: #000;
      }
      .tableFooter .headTableContentCirculation {
        width: 220px;
        color: #000;
      }
      .tableFooter .describe {
        width: 80%;
        margin: 0 auto;
      }
      .tableFooter .pagination {
        background: #fff !important;
        text-align: center;
      }
      .tableFooter .pagination span:nth-child(1) {
        margin-right: 20px;
      }
      .headclass .el-descriptions {
        border-top: 1px solid #000;
        border-left: 1px solid #000;
        border-right: 1px solid #000;
      }
      .footclass .el-descriptions {
        border-top: none;
        border-bottom: 1px solid #000;
        border-left: 1px solid #000;
        border-right: 1px solid #000;
      }
      .footTableLabel {
        width: 130px;
        background: #fff !important;
        color: #000 !important;
        font-weight: 400;
      }
      .headTableLabelSumContext {
        width: 100px;
        color: #000 !important;
        background-color: #fff !important;
        font-weight: 400;
      }
      .sumContext {
        margin-bottom: -1px;
      }
      .footclass .sumContext {
        margin-bottom: 0px;
      }
      </style>`
    }
  },
  created() {
    this.getOverallSet()
    this.getDetails()
  },
  methods: {
    async getOverallSet() {
      this.loading = true
      const { data: res } = await this.$http.post('/Account/_public/printGlobalParam.html')
      this.loading = false
      if (res.code != '0') return this.$alert(res.msg, '提示', {
        confirmButtonText: '确定'
      })
      this.controlForm = res.data
      console.log(this.controlForm);
    },
    async getDetails() {
      this.loading = true
      const { data: res } = await this.$http.post('/Account/salOrder/oneTicketBatchPrint.html', this.Qs.stringify({ billNo: this.billNo }))
      this.loading = false
      if (res.code != '0') return this.$alert(res.msg, '提示', {
        confirmButtonText: '确定'
      })
      this.oneTicketPrintList = res.data
    },
    onSubmit(tag) {
      let LODOP = getLodop()
      if (this.controlForm.isPrintPage == 'Y') {
        $('.main').each((index, item) => {
          let head = '<div class="tableHead">' + $(item).find('.tableHead').html() + '</div>'
          let table = this.bodyStyle + $(item).find('.tableBody').html()
          let footer = '<div class="tableFooter">' + $(item).find('.tableFooter').html() + '</div>'
          let column = $(table).find('colgroup col').size()
          let div = document.createElement('div')
          let height = $(item).find('.tableHead').height()
          $(div).append(table)
          if (this.controlForm.isPrintHead == 'Y') {
            $(div).find('thead').prepend(`<tr style="height: ${height}px; width: 100%;"><td colspan="${column}" class='headclass' style='position:absolute; width: 100%; background-color: #fff; border: none;'>${head}</td></tr>`)
          } else {
            LODOP.ADD_PRINT_HTM(this.controlForm.printLodopMarginTop, this.controlForm.printLodopMarginLeft, "100%", "100%", this.bodyStyle + head)
          }
          if (this.controlForm.isPrintFooter == 'Y') {
            $(div).find('tfoot').append(`<tr><td colspan="${column}" class='footclass' style='position:absolute; width: 100%; background-color: #fff; border: none;'>${footer}</td></tr>`)
          }
          if (this.controlForm.isPrintHead == 'Y') {
            LODOP.ADD_PRINT_TABLE(this.controlForm.printLodopMarginTop, this.controlForm.printLodopMarginLeft, "100%", "100%", $(div).html());

          } else {
            LODOP.ADD_PRINT_TABLE(0, 0, "100%", "100%", $(div).html());
            LODOP.SET_PRINT_STYLEA(0, "LinkedItem", -1);
          }
          if (this.controlForm.isPrintFooter != 'Y') {
            LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", this.bodyStyle + footer)
            LODOP.SET_PRINT_STYLEA(0, "LinkedItem", -1);
          }
          LODOP.SET_PRINT_PAGESIZE(1, this.controlForm.printLodopWidth + "mm", this.controlForm.printLodopHeight + "mm", "");
          LODOP.NewPageA();
        })
      } else {
        let allData = this.bodyStyle
        $('.main').each((index, item) => {
          let head = '<div class="tableHead">' + $(item).find('.tableHead').html() + '</div>'
          let table = $(item).find('.tableBody').html()
          let footer = '<div class="tableFooter">' + $(item).find('.tableFooter').html() + '</div>'
          allData += head + table + footer
        })
        LODOP.ADD_PRINT_HTM(this.controlForm.printLodopMarginTop, this.controlForm.printLodopMarginLeft, "100%", "100%", allData)
        LODOP.SET_PRINT_PAGESIZE(3, this.controlForm.printLodopWidth + "mm", this.controlForm.bottomLodopHeight + "mm", "");
      }
      if (LODOP.CVERSION) CLODOP.On_Return = (taskID, value) => {
        console.log(taskID, value)
        if (tag == 1) {
          if (value > 0) {
            this.batchUpdateBillPrintCount(value)
          }
        } else {
          if (value) {
            this.batchUpdateBillPrintCount(1)
          }
        }
      }
      if (tag == 1) {
        LODOP.PREVIEW();
      } else {
        LODOP.PRINT();
      }
    },
    batchUpdateBillPrintCount(value) {
      let params = {
        billNos: this.billNo,
        // billType: this.controlFrom.billType,
        printCount: value
      }
      console.log(params)
      $.post('/Account/PrintSet/updateSysCountPrint.html', params)
    }

  }
}
</script>

<style scoped lang="less">
.tableBody {
  width: 100%;
  overflow: hidden;
}

.tableBody .table {
  width: 100%;
}

.tableFooter,
.tableHead {
  width: 100%;
}

::v-deep .form-item .el-form-item__content {
  text-align: center;
}

.table thead>tr:not(.noSetHeight) th:not(.headclass),
.table tbody>tr td,
.table tfoot>tr:not(.noSetHeight) td:not(.footclass) {
  box-sizing: border-box;
  padding: 2px 4px;
}

#tab {
  font-size: 16px;
}

#tab .bold {
  font-weight: bold;
}

::v-deep .el-descriptions {
  .is-bordered .el-descriptions-item__cell {
    border: 1px solid #000;
    padding: 0 12px;
  }
  .is-bordered .el-descriptions-item__cell {
    border: 1px solid #000;
  }
  .headTableLabel {
    width: 120px;
    background: #fff !important;
    color: #000 !important;
  }
  .headTableContent {
    min-width: 50px;
    color: #000 !important;
  }
  .headTableContentCirculation {
    width: 220px;
    color: #000;
  }
  .footTableLabel {
    width: 130px;
    background: #fff !important;
    color: #000 !important;
    font-weight: 400;
  }
  .headTableLabelSumContext {
    width: 100px;
    color: #000 !important;
    background-color: #fff !important;
  }
}

#tab .tableHead .title>p:nth-child(1) {
  font-size: 24px;
  text-align: center;
}

#tab .tableHead .title>p:nth-child(2) {
  display: flex;
  justify-content: space-between;
}

#tab .tableHead .title>p:nth-child(2) .headDate {
  width: 200px;
  font-size: 18px;
}

#tab .tableHead .headTableContentCirculation {
  width: 230px;
  color: #000;
}

#tab .tableFooter .describe {
  width: 80%;
  margin: 0 auto;
}

#tab .tableFooter .pagination {
  background: #fff;
  text-align: center;
}

#tab .tableFooter .pagination span:nth-child(1) {
  margin-right: 20px;
}
.sumContext {
  margin-bottom: -1px;
}

</style>